// extracted by css-extract-rspack-plugin
var _1 = "filter-xvJXW_";
var _2 = "table-KUfOdV";
export { _1 as "filter", _2 as "table" }
